import * as ImagePicker from 'expo-image-picker';
import { useSnackbar } from '../contexts/useSnackbar';
import { MAX_PHOTO_SIZE } from '../utils/media';

export function useImagePicker() {
  const { showSnackbar } = useSnackbar();

  const getFileSize = async (uri: string): Promise<number> => {
    try {
      const response = await fetch(uri);
      const blob = await response.blob();
      return blob.size;
    } catch (error) {
      console.error('Error getting file size:', error);
      return 0;
    }
  };

  return async () => {
    // No permissions request is necessary for launching the image library
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.Images,
      allowsEditing: true,
      aspect: [1, 1],
      quality: 1,
      base64: true,
    });

    if (!result.canceled) {
      const asset = result.assets[0];
      const fileSize = await getFileSize(asset.uri);

      if (fileSize > MAX_PHOTO_SIZE) {
        const fileSizeMB = (fileSize / (1024 * 1024)).toFixed(1);
        const maxFileSizeMB = (MAX_PHOTO_SIZE / (1024 * 1024)).toFixed(1);
        showSnackbar({
          text: `Image size (${fileSizeMB}MB) exceeds the ${maxFileSizeMB}MB limit. Please choose a smaller image.`,
          type: 'error',
        });
        return null;
      }

      return asset;
    }
  };
}
